module.exports = __webpack_public_path__ + "static/media/icra20paper.42b8d6f1.png";